import React, { useState, useEffect } from "react";
import "./style.css";

export default function CivilEngineering() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        padding: windowWidth > 768 ? "100px" : "10px",
        backgroundColor: "#f0f0f0",
        borderRadius: "10px",
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
        margin:
          windowWidth > 768 ? "200px 20px 100px 20px" : "50px 20px 50px 20px",
        textAlign: windowWidth > 768 ? "justify" : "left",
      }}
    >
      <h2 style={{ marginTop: "20px", marginBottom: "20px" }}>
        B.Tech - Civil Engineering
      </h2>

      <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
        1. Comprehensive Curriculum
      </h3>
      <p style={{ marginTop: "10px", marginBottom: "10px", fontSize: "22px" }}>
        The B.Tech in Civil Engineering at JSS Academy of Technical Education,
        Noida, established in 2007, is designed to foster excellence in
        construction, structural engineering, water resources, geotechnical
        engineering, remote sensing, and GIS. The curriculum integrates core
        civil engineering principles with practical applications, preparing
        students to address societal needs and industry challenges.
      </p>
      <ul className="course-section">
        <li>
          <strong>Core Civil Engineering Knowledge:</strong> The program covers
          foundational subjects such as Structural Analysis, Fluid Mechanics,
          Geotechnical Engineering, Surveying, and Transportation Engineering,
          equipping students with the skills to design and manage infrastructure
          projects.
        </li>
        <li>
          <strong>Specialized Courses:</strong> Advanced courses include
          Environmental Engineering, Remote Sensing, GIS, and Construction
          Management, enabling students to tackle modern challenges like
          sustainable infrastructure and urban planning.
        </li>
        <li>
          <strong>Practical Learning:</strong> Emphasis on hands-on learning
          through labs, field surveys, and projects allows students to work with
          tools like Total Stations, Compression Testing Machines, and software
          like STAAD.Pro, ensuring industry-relevant experience.
        </li>
        <li>
          <strong>Capstone Projects:</strong> Final-year students undertake
          capstone projects, often in collaboration with industry, applying
          their knowledge to solve real-world problems such as designing
          sustainable structures or developing smart city solutions.
        </li>
      </ul>

      <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
        2. Future Scope and Job Opportunities
      </h3>
      <p style={{ marginTop: "10px", marginBottom: "10px", fontSize: "22px" }}>
        Civil engineering is a dynamic field with vast career opportunities
        driven by global infrastructure development and sustainability needs.
      </p>
      <ul className="course-section">
        <li>
          <strong>Diverse Career Opportunities:</strong> Graduates can pursue
          roles such as Structural Engineers, Geotechnical Engineers,
          Transportation Engineers, Environmental Engineers, Construction
          Managers, or Urban Planners in industries like construction,
          government, and consulting.
        </li>
        <li>
          <strong>Growing Demand:</strong> Rapid urbanization and infrastructure
          projects worldwide ensure strong demand for civil engineers, offering
          competitive salaries and job stability.
        </li>
        <li>
          <strong>Emerging Trends:</strong> The curriculum prepares students for
          trends like green building, smart cities, and disaster-resistant
          structures, aligning with global sustainability and innovation goals.
        </li>
        <li>
          <strong>Global Career Opportunities:</strong> Transferable skills
          enable graduates to work in international markets, contributing to
          mega-projects in regions like the Middle East, Europe, or North
          America.
        </li>
        <li>
          <strong>Entrepreneurship:</strong> Graduates can launch their own
          firms, providing services in construction, consulting, or innovative
          solutions like eco-friendly materials and technologies.
        </li>
      </ul>

      <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
        3. Higher Studies and Research Opportunities
      </h3>
      <p style={{ marginTop: "10px", marginBottom: "10px", fontSize: "22px" }}>
        The B.Tech in Civil Engineering provides a strong foundation for
        advanced studies and research, fostering innovation in infrastructure
        and sustainability.
      </p>
      <ul className="course-section">
        <li>
          <strong>Advanced Degrees:</strong> Graduates can pursue M.Tech, MS, or
          Ph.D. in fields like Structural Engineering, Environmental
          Engineering, or Geotechnical Engineering, supported by a rigorous
          curriculum meeting global academic standards.
        </li>
        <li>
          <strong>Research-Oriented Learning:</strong> The department’s research
          lab and faculty publications in national/international journals
          encourage students to explore topics like sustainable materials,
          seismic design, and smart infrastructure.
        </li>
        <li>
          <strong>Collaborative Research:</strong> MOUs with industry and
          academic institutions facilitate interdisciplinary research, leading
          to publications and presentations at conferences, enhancing students’
          research profiles.
        </li>
        <li>
          <strong>Innovation Focus:</strong> The Association of Civil Engineers
          (ACE) and student clubs foster innovative ideas, preparing students
          for research-driven careers and contributions to advancements in civil
          engineering.
        </li>
      </ul>

      <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
        4. State-of-the-Art Infrastructure
      </h3>
      <p style={{ marginTop: "10px", marginBottom: "10px", fontSize: "22px" }}>
        JSS Academy offers cutting-edge infrastructure, supporting the
        specialized needs of the B.Tech in Civil Engineering with advanced
        facilities and tools.
      </p>
      <ul className="course-section">
        <li>
          <strong>Advanced Laboratories:</strong> Labs like Basic Surveying,
          Concrete and Highway Material, and Environmental Engineering are
          equipped with tools such as Total Stations, Compression Testing
          Machines, and BOD Incubators for hands-on learning.
        </li>
        <li>
          <strong>Computer-Aided Design Lab:</strong> Industry-standard software
          like STAAD.Pro, AutoCAD, and Bentley suites enables students to design
          and analyze complex structures digitally.
        </li>
        <li>
          <strong>Smart Classrooms:</strong> Equipped with LCD projectors and
          podiums, spacious classrooms enhance interactive learning, supporting
          visual and hybrid teaching models.
        </li>
        <li>
          <strong>Department Library:</strong> A well-stocked library with over
          1050 books, journals, e-journals, and project reports, open daily,
          supports academic and research needs.
        </li>
        <li>
          <strong>Research and Project Lab:</strong> Dedicated spaces foster
          innovation, allowing students to develop and test new ideas in civil
          engineering applications.
        </li>
      </ul>

      <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
        5. Industry Connections and Placement Support
      </h3>
      <p style={{ marginTop: "10px", marginBottom: "10px", fontSize: "22px" }}>
        The B.Tech in Civil Engineering benefits from strong industry ties and
        comprehensive placement support, ensuring a smooth transition to
        professional careers.
      </p>
      <ul className="course-section">
        <li>
          <strong>Industry-Academia Collaboration:</strong> Partnerships with
          construction industries and professional bodies ensure the curriculum
          aligns with industry needs, supplemented by workshops, seminars, and
          expert talks.
        </li>
        <li>
          <strong>Internships and Live Projects:</strong> MOUs facilitate
          internships and industry visits, providing practical experience and
          often leading to job offers from reputed firms.
        </li>
        <li>
          <strong>Dedicated Placement Cell:</strong> The Training and Placement
          division offers resume-building, interview skills, and soft skills
          training, organizing campus drives with top companies.
        </li>
        <li>
          <strong>Global Career Opportunities:</strong> Strong industry
          connections enable graduates to secure roles in multinational firms,
          both in India and abroad, in challenging and rewarding positions.
        </li>
        <li>
          <strong>Strong Alumni Network:</strong> Alumni in prominent roles
          mentor students, offer internships, and provide networking
          opportunities, enhancing career prospects.
        </li>
      </ul>

      <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
        6. Holistic Development
      </h3>
      <p style={{ marginTop: "10px", marginBottom: "10px", fontSize: "22px" }}>
        JSS Academy is committed to holistic development, ensuring students
        graduate as well-rounded professionals ready to excel in civil
        engineering.
      </p>
      <ul className="course-section">
        <li>
          <strong>Technical and Non-Technical Clubs:</strong> The Association of
          Civil Engineers (ACE) and student clubs promote technical innovation,
          while cultural, sports, and arts clubs nurture diverse interests.
        </li>
        <li>
          <strong>Soft Skills Enhancement:</strong> The program emphasizes
          communication, leadership, teamwork, and problem-solving skills,
          critical for professional success in interdisciplinary teams.
        </li>
        <li>
          <strong>Social Initiatives and Community Service:</strong> Students
          apply civil engineering skills to projects like sustainable
          infrastructure or disaster-resilient designs, fostering social
          responsibility.
        </li>
        <li>
          <strong>Global Exposure:</strong> Industry visits, internships, and
          collaborations with global institutions provide international
          exposure, preparing students for diverse work environments.
        </li>
        <li>
          <strong>Mental and Physical Well-being:</strong> Counseling services,
          fitness centers, and wellness programs support students’ health,
          ensuring academic and personal success.
        </li>
      </ul>

      <p style={{ marginTop: "20px", marginBottom: "20px", fontSize: "22px" }}>
        The B.Tech in Civil Engineering at JSS Academy of Technical Education,
        Noida, is a comprehensive program equipping students with the skills and
        knowledge to excel in the dynamic field of civil engineering. With a
        robust curriculum, state-of-the-art infrastructure, and strong industry
        connections, students are prepared to tackle global infrastructure
        challenges. Whether aiming for top industry roles, advanced studies, or
        entrepreneurial ventures, this program provides the foundation for
        success.
      </p>
    </div>
  );
}
